<template>
  <div v-loading="loading" class="contract-annexes-container">
    <div class="default-table">
      <el-table border :data="tableData" v-on="$listeners" v-bind="$attrs">
        <el-table-column label="序号" prop="index" width="80" align="center">
          <template slot-scope="scope">
            <span :title="`ID：${scope.row.id}`">{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="name"
            label="文件名" align="center" min-width="200">
        </el-table-column>
        <!--              <el-table-column-->
        <!--                  prop="url"-->
        <!--                  label="文件路径" align="center" min-width="220" :show-overflow-tooltip="true">-->
        <!--              </el-table-column>-->
        <el-table-column
            prop="size"
            label="大小" align="right" header-align="center" min-width="120">
          <template slot-scope="scope">
            <span>{{ fileSizeName(scope.row.size) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="created_at" width="160" align="center"></el-table-column>
        <el-table-column
            label="操作" align="center" min-width="160">
          <template slot-scope="scope">
            <el-link type="primary" @click="handelPreviewFiles" style="margin-right: 8px;">
              <i class="el-icon-document"/>预览
            </el-link>
            <export-link
                class="down-file"
                @export="downLoadFile(scope.row.file_id,scope.row.name)"
                :ref="`refExportLink${scope.row.file_id}`"
                :can-export="!!(scope.row.url)"
                :lint-title="`下载`"
            />
            <el-link type="danger" @click="upFileListDel(scope.$index,scope.row.id)" v-if="showOptDel">
              <i class="el-icon-delete"></i>删除
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {mTofixed} from "@/views/adOrder";
import {delContractAnnex, getContractAnnexList} from "@/api/adOrder";
import {downloadByFileId} from "@/api/download_file";

export default {
  name: "ContractAnnexes",
  props: {
    currentRow: {
      type: Object,
      default() {
        return {};
      }
    },
    upFileList: {
      type: Array,
      default() {
        return [];
      }
    },
    showOptDel: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  computed: {
    tableData() {
      return [...this.dataList, ...this.upFileList]
    }
  },
  data() {
    return {
      dataList: [],
      loading: false
    }
  },
  watch: {
    'currentRow.id'() {
      this.getList()
    },
  },
  methods: {
    handelPreviewFiles: function () {
      const {customer_name, contract_no, id} = this.currentRow
      const title = `${customer_name}「${contract_no}」`

      const {href} = this.$router.resolve({
        name: `FilesPreview`,
        query: {id, title, type: 'contract'}
      });
      window.open(href, "_blank");
    },
    // 文件大小单位
    fileSizeName(size) {
      if (size < 1024) {
        return size + ' ' + 'bit'
      } else if (size >= 1024 && size < (1024 * 1024)) {
        return mTofixed((size * 0.001), 2) + ' ' + 'kB'
      } else if (size >= (1024 * 1024)) {
        return mTofixed((size * 0.001 * 0.001), 2) + ' ' + 'MB'
      }
    },
    /**
     * 下载文件
     * @param id
     * @param name
     * @returns {Promise<void>}
     */
    async downLoadFile(id, name) {
      try {
        let isFileSaverSupported = !!new Blob()
        if (isFileSaverSupported) {
          const response = await downloadByFileId({id})
          const data = response.data
          const contentType = response.headers['content-type']
          const blob = new Blob([data], {type: contentType})
          this.FileSaver.saveAs(blob, decodeURI(name), {autoBom: true})
          this.$refs[`refExportLink${id}`].loadingDownload = false;
        } else {
          this.$message.warning('浏览器不支持导出文件')
        }
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
      }
    },
    async upFileListDel(index, id) {
      this.$emit('upFileListDel')
      if (id) {
        this.$msgbox.confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {

          await delContractAnnex({id: id})
          this.dataList.splice(index, 1)
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      } else {
        this.dataList.splice(index, 1)
      }
    },
    async getList() {
      this.loading = true
      this.dataList = []
      let {list} = await getContractAnnexList({contract_id: this.currentRow.id}).then((res) => {
        // console.log(res)
        return res.data
      })
      this.$nextTick(() => {
        this.dataList = list
      })
      this.loading = false
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style lang="scss">
.contract-annexes-container {
  .down-file {
    margin-right: 8px;

    i, span {
      font-size: 14px !important;
      margin-left: 0 !important;
    }
  }
}
</style>
